import { gql, useQuery } from '@apollo/client';

export const GET_SOFTWARE_PLAN_BY_ID = gql`
  query ($id: String!) {
    getSoftwarePlanByIdForModule(id: $id) {
      _id
      name
      currency
      baseFeature {
        _id
        name
      }
      additionalFeatures {
        _id
        name
      }
    }
  }
`;

export const useGetSoftwarePlanById = (id: string) => {
  const { data, loading } = useQuery(GET_SOFTWARE_PLAN_BY_ID, { variables: { id }, skip: !id });
  const { getSoftwarePlanByIdForModule = {} } = data || {};

  return { softwarePlan: getSoftwarePlanByIdForModule, loading };
};
